// ══════════════════════════════════════════════════════════════════════════════
// PAGE ASSISTANT IA - COCKPIT PRO
// Route: /cockpit-pro/assistant
// Design Style Claude avec AssistantFullPage
// ══════════════════════════════════════════════════════════════════════════════

import { useNavigate, useOutletContext } from 'react-router-dom';
import AssistantFullPage from '../assistant/AssistantFullPage';

export default function AssistantProPage() {
  const navigate = useNavigate();
  const { userProfile } = useOutletContext() || {};
  
  return (
    <div className="fixed inset-0 z-[9999] bg-white">
      <AssistantFullPage 
        userContext="pro"
        onClose={() => navigate('/cockpit-pro')}
      />
    </div>
  );
}
